import React, {useContext, Fragment} from 'react';
import clsx from 'clsx';
import {Avatar, Dropdown, Grid, List, Switch} from 'antd';
import {FaChevronDown} from 'react-icons/fa';
import {BsMoonStars, BsSun} from 'react-icons/bs';
import './index.style.less';
import {useThemeContext} from '../../../../utility/AppContextProvider/ThemeContextProvider';
import {useLocaleContext} from '../../../../utility/AppContextProvider/LocaleContextProvide';
import {AuthContext} from '../../../../../pages/auth/context';
import IntlMessages from '../../../../utility/IntlMessages';
import {UserOutlined} from '@ant-design/icons';
import {getShopName} from '../../../../../shared/functions/shop-name';
import {useShopAdminShop} from '../../../../../shared/hooks/useShopAdminShop';
import {useDarkMode} from '../../../../../shared/hooks/useDarkMode';

const UserInfo = () => {
  const {themeMode}: any = useThemeContext();
  const {setVisibleLogout}: any = useContext(AuthContext);
  const {locale} = useLocaleContext();
  // A shop admin sees their shop's name and logo instead of "Admin".
  // While that isn't known yet, a placeholder rather than "Admin" first.
  const {shop, logoUrl, loading} = useShopAdminShop();
  const displayName = (shop && getShopName(shop, locale?.code)) || 'Admin';
  const [darkMode, setDarkMode] = useDarkMode();
  // Small screens have no room for the navbar's sun/moon button: the switch
  // sits in this menu instead.
  const {sm} = Grid.useBreakpoint();

  const menu = (
    <List className='dropdown-list'>
      {!sm && (
        <List.Item
          className='dropdown-list-toggle'
          onClick={() => setDarkMode(!darkMode)}>
          <span className='dropdown-list-icon'>
            {darkMode ? <BsSun /> : <BsMoonStars />}
          </span>
          <List.Item.Meta title={<IntlMessages id='touch.darkMode' />} />
          <Switch size='small' checked={darkMode} />
        </List.Item>
      )}
      <List.Item onClick={() => setVisibleLogout(true)}>
        <List.Item.Meta title={<IntlMessages id='common.logout' />} />
      </List.Item>
    </List>
  );

  return (
    <Fragment>
      <div
        className={clsx('cr-user-info', {
          light: themeMode === 'light',
        })}>
        <Dropdown
          overlay={menu}
          trigger={['click']}
          placement='bottomRight'
          overlayStyle={{
            zIndex: 1052,
            minWidth: 150,
          }}>
          <a className='cr-user-info-inner ant-dropdown-link'>
            <Avatar
              size={35}
              className={clsx({'cr-user-info-logo': logoUrl})}
              src={logoUrl}
              icon={loading ? undefined : <UserOutlined />}
            />
            <span className='cr-user-info-content'>
              <span className='cr-user-name-info'>
                <h3
                  className={clsx('cr-user-name', {
                    light: themeMode === 'light',
                  })}>
                  {loading ? (
                    <span className='touch-name-placeholder' aria-hidden='true' />
                  ) : (
                    displayName
                  )}
                </h3>
                <span className='cr-user-arrow'>
                  <FaChevronDown />
                </span>
              </span>
            </span>
          </a>
        </Dropdown>
      </div>
    </Fragment>
  );
};

export default UserInfo;
